"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _StudioVideoUplinkBandwidthPolicy = require("./StudioVideoUplinkBandwidthPolicy");
Object.keys(_StudioVideoUplinkBandwidthPolicy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StudioVideoUplinkBandwidthPolicy[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _StudioVideoUplinkBandwidthPolicy[key];
    }
  });
});
var _ActiveSpeakerPolicy = require("./ActiveSpeakerPolicy");
Object.keys(_ActiveSpeakerPolicy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ActiveSpeakerPolicy[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ActiveSpeakerPolicy[key];
    }
  });
});